export const hideText = (text: string): string => text.replace(/./g, "*")
